var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShieldOutline = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333,
  d: "M13.335 8.667c0 3.333-2.334 5-5.107 5.966a.666.666 0 0 1-.447-.006c-2.78-.96-5.113-2.627-5.113-5.96V4a.667.667 0 0 1 .667-.667c1.333 0 3-.8 4.16-1.813a.78.78 0 0 1 1.013 0c1.167 1.02 2.827 1.813 4.16 1.813a.667.667 0 0 1 .667.667v4.667Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgShieldOutline);
export default ForwardRef;